"use strict";
(function (global) {

  /**
  * Редактор для компоненты slick-грида, для реквизита типа "Многострочный текст"
  * @class WebAccess.components.dataViews.gridPlugins._editors.FloatEditor
  * @extends WebAccess.components.dataViews.gridPlugins._editors.StringEditor
  * @since 5.2.0.1300 
  */
  global.TextEditor = global.StringEditor.extend({});

})(window.WA.components.dataViews.gridPlugins._editors)